import { JobCategoryPageTransformerData } from '@/features/job-category-page/hygraph/transformers/job-category-page.transformer';
import { JobCategoryPage } from '@/features/job-category-page/types';
import { JobCategoryPageRouteParams } from '@/features/job-category-page/utils/route-utils';
import {
  isAlliedHealth,
  isNurse,
  isTravelAllied,
  isTravelNurse,
} from '@/utils/discipline-utils';

type JobCategoryValidationData =
  | JobCategoryPageTransformerData
  | Partial<JobCategoryPage>
  | JobCategoryPageRouteParams;

// page validators
export const isPageAlliedHealth = (data: JobCategoryValidationData) => {
  return isAlliedHealth(data.disciplineType);
};

export const isPageNurse = (data: JobCategoryValidationData) => {
  return isNurse(data.disciplineType);
};

export const isPageTravelAllied = (data: JobCategoryValidationData) => {
  return (
    isAlliedHealth(data.disciplineType) &&
    isTravelAllied(data.disciplineSubType)
  );
};

export const isPageTravelNurse = (data: JobCategoryValidationData) => {
  return isNurse(data.disciplineType) && isTravelNurse(data.disciplineSubType);
};
